import { useState } from 'react';

import { useMutation } from '@redwoodjs/web';

import { showErrorToast } from 'src/components/Toasts/toast';
import { DELETE_SEPA_DD_MANDATE_AGREEMENT } from 'src/graphql/mutations/sepaMandate.mutation';
import { onError } from 'src/utils/utils';

import { UseDeleteSepaAgreementProps } from './type';

export default function useDeleteSepaAgreement({
    handleOnDeleteSepaMandate,
}: UseDeleteSepaAgreementProps) {
    const [idToDelete, setIdToDelete] = useState<number | null>(null);

    const [deleteSepaMandate] = useMutation(DELETE_SEPA_DD_MANDATE_AGREEMENT, {
        onError,
        onCompleted: (data) => {
            handleOnDeleteSepaMandate(data);
        },
    });

    const handleDeleteSepaMandate = () => {
        if (idToDelete) {
            deleteSepaMandate({
                variables: {
                    id: idToDelete,
                },
            });
        } else {
            showErrorToast('Failed to delete Direct Debit Mandate.');
        }
    };

    return {
        handleDeleteSepaMandate,
        setIdToDelete,
    };
}
